module.exports = __webpack_public_path__ + "images/index/culture_description_img_2.a432002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/culture_description_img_2.png
// module id = dNph
// module chunks = 21